export const jsmContextualRovoPromptWindowDays = 60;
